export const environment = {
  apiUrl: 'https://api.new.thecarpspecialist.com',
};
